module.exports = __webpack_public_path__ + "media/images/svgs/sub_menu/helper-bdfab86b2f6020602c5cbd9f2db83833.svg";